<template>
  <div v-if="hasCompany" class="add-company-details">
    <form v-if="isEditing" class="add-company-details__form" @submit.prevent="submit">
      <app-fieldset title="Extra gegevens">
        <form-input
          id="company-invoice-name"
          v-model="company.CustomerCompanyInvoiceName"
          title="Factuurnaam"
          type="text"
        />
        <form-input
          id="company-extra-contact"
          v-model="company.CustomerCompanyContact"
          title="Contactpersoon"
          type="text"
        />
        <form-input
          id="company-extra-remarks"
          v-model="company.CustomerCompanyInternalMessage"
          title="Opmerkingen"
          type="text"
        />
      </app-fieldset>

      <app-button type="submit" button-type="cta" data-qa="company-extra-details-save-button">{{
        i18n.t('/Common/Save')
      }}</app-button>
      <app-button data-qa="company-extra-details-cancel-button" @click="isEditing = false">
        {{ i18n.t('/Common/Cancel') }}
      </app-button>
    </form>

    <div v-else-if="hasCompanyDetails">
      <dl class="company-extra-details">
        <dt>{{ i18n.t('/Company/ExtraCompanyDetails/Invoice name') }}</dt>
        <dd>{{ company.CustomerCompanyInvoiceName }}</dd>
        <dt>{{ i18n.t('/Company/ExtraCompanyDetails/Contact person') }}</dt>
        <dd>{{ company.CustomerCompanyContact }}</dd>
        <dt>{{ i18n.t('/Company/ExtraCompanyDetails/Remarks') }}</dt>
        <dd>{{ company.CustomerCompanyInternalMessage }}</dd>
      </dl>
    </div>

    <app-button
      v-if="canEdit && !isEditing"
      data-qa="company-extra-details-edit-button"
      @click="isEditing = true"
    >
      {{ i18n.t('/Company/ExtraCompanyDetails/Edit') }}
    </app-button>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import AppFieldset from '@/components/generic/presentational/atoms/appFieldset/AppFieldset.vue'
import FormInput from '@/components/generic/presentational/atoms/formInput/FormInput.vue'
import StoreConnector from '@/helpers/StoreConnector'

export default {
  components: {
    AppButton,
    AppFieldset,
    FormInput,
  },
  data() {
    return {
      isEditing: false,
      isEditable: false,
      hasCompany: false,
      company: null,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    canEdit() {
      return this.isEditable && this.hasCompany
    },
    hasCompanyDetails() {
      return (
        this.company?.CustomerCompanyInvoiceName ||
        this.company?.CustomerCompanyContact ||
        this.company?.CustomerCompanyInternalMessage
      )
    },
  },
  created() {
    StoreConnector.get('quote/hasCustomerCompany', (data) => {
      this.hasCompany = data
    })

    StoreConnector.get('quote/customerCompany', (data) => {
      this.company = data
    })

    StoreConnector.get('quote/quoteStatusIsSalesOrder', (data) => {
      this.isEditable = !data
    })
  },
  methods: {
    submit() {
      StoreConnector.dispatch('quote/createOrUpdate', this.company).then(
        () => (this.isEditing = false)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.company-extra-details {
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin-bottom: 1em;
}
</style>
